// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__mxYZ_","title":"styles_title__MYvwG","content":"styles_content__K2_9b","buttonWrapper":"styles_buttonWrapper__G3N5Y","textLink":"styles_textLink__1cnGV"};
module.exports.__checksum = "dff29aad6a99"